import { ViewCell, ViewConfig } from "@lib/views";
import { WorkspaceEmailAliasKind } from "@common/constants/domains/receipts/constants";
import { LocalPartCell } from "../cells/LocalPartCell";
import { LimitCell } from "../cells/LimitCell";
import { EmailAliasActionsCell } from "../cells/EmailAliasActionsCell";
import { VendorCell } from "../cells/VendorCell";

export enum EmailAliasColumn {
    LOCAL_PART = "localPart",
    VENDOR = "vendor",
    LIMIT = "limit",
    ACTIONS = "actions",
}

export interface EmailAliasRow {
    id: string;
    emailLocalPart: string;
    limit: number | null;
    workspaceId: string;
    kind: WorkspaceEmailAliasKind;
    counterpartyId: string | null;
    counterpartyName: string | null;
    isDefault: boolean;
    createdAt: Date;
    updatedAt: Date;
}

export const emailAliasesViewConfig: ViewConfig<
    EmailAliasRow,
    EmailAliasColumn,
    never
> = {
    columns: {
        [EmailAliasColumn.LOCAL_PART]: {
            accessorKey: "emailLocalPart",
            name: "Local Part",
            header: "Email",
            cell: LocalPartCell,
            minSize: 200,
            maxSize: 1000,
        },
        [EmailAliasColumn.VENDOR]: {
            accessorKey: "counterpartyName",
            name: "Counterparty",
            header: "Counterparty",
            cell: VendorCell,
            minSize: 160,
            maxSize: 400,
        },
        [EmailAliasColumn.LIMIT]: {
            accessorKey: "limit",
            name: "Limit",
            header: "Limit",
            cell: LimitCell,
            minSize: 100,
            maxSize: 150,
        },
        [EmailAliasColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            cell: EmailAliasActionsCell as unknown as ViewCell<
                EmailAliasRow,
                string
            >,
            minSize: 60,
            maxSize: 60,
            immutable: true,
            hiddenFromSettings: true,
        },
    },
};
